import { render, staticRenderFns } from "./PracticaEjerciciosAvanzado.vue?vue&type=template&id=894af566&"
import script from "./PracticaEjerciciosAvanzado.vue?vue&type=script&lang=js&"
export * from "./PracticaEjerciciosAvanzado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports